<eventq-dialog-popover
  [open]="open()"
  title="AI Feedback"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="submitDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div
    class="ai-feedback-popover__banner"
    [style.background-color]="config().bannerBg"
  >
    <span class="ai-feedback-popover__icon" aria-hidden="true">
      <img [src]="config().iconSrc" alt="" />
    </span>
    <p class="ai-feedback-popover__prompt">{{ config().prompt }}</p>
  </div>
</eventq-dialog-popover>
